const ColumnNames = {
  name: 'Tag',
  security: 'Security',
  size: 'Size',
  lastModified: 'Last Modified',
  expires: 'Expires',
  digest: 'Digest',
  lastPulled: 'Last Pulled',
  pullCount: 'Pull Count',
  pull: 'Pull',
};

export default ColumnNames;
